import { Spinner } from '@monksflow/monks-ui';
import { OptimizedImage } from '../OptimizedImage';

export const Loading = () => {
  return (
    <div className="flex items-center justify-center h-full">
      <Spinner size="xl" />
    </div>
  );
};

export const SpinningIcon = ({
  src,
  alt,
  width = 18,
  height = 18,
}: {
  src: string;
  alt: string;
  width?: number;
  height?: number;
}) => {
  return (
    <div data-testid="spinning-icon" className="animate-spin">
      <OptimizedImage src={src} alt={alt} width={width} height={height} priority />
    </div>
  );
};
